import type {PersistedState} from 'redux-persist';

export const authPersistBlacklist = ['logoutInProgress'];

type PersistedAuthState = NonNullable<PersistedState> & {
    logoutInProgress?: boolean;
};

/**
 * Logout is an in-memory transition guard. It must survive clearAuthData while
 * Keycloak is redirecting, but it must never survive a page reload/new login.
 * Also remove values written by older application versions so existing users
 * do not remain stuck on the "Not authenticated" screen after this fix ships.
 */
export async function migrateAuthState(state: PersistedState): Promise<PersistedState> {
    if (!state) return state;

    const migratedState: PersistedAuthState = {...state};
    delete migratedState.logoutInProgress;
    return migratedState;
}
